import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useListarLojasQuery } from '@/services/migrate';
import { ScrollArea } from "@/components/ui/scroll-area";

interface StoreSelectProps {
  value: string;
  onChange: (cnpj: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

const StoreSelect = ({ value, onChange, disabled, placeholder = "Selecione a loja" }: StoreSelectProps) => {
  const { data: stores, isLoading } = useListarLojasQuery();

  return (
    <Select
      value={value}
      onValueChange={onChange}
      disabled={disabled || isLoading}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder={isLoading ? "Carregando..." : placeholder} />
      </SelectTrigger>
      <SelectContent>
        <ScrollArea className="h-[300px]">
          {stores?.map((store) => (
            <SelectItem key={store.cnpj} value={store.cnpj}>
              Loja {String(store.loja).padStart(3, '0')} - {store.cnpj}
            </SelectItem>
          ))}
        </ScrollArea>
      </SelectContent>
    </Select>
  );
};

export default StoreSelect;
